<script type="text/javascript">
	import Icon from "../icon.svelte";
	export let opened = true;
	
	let closing = false;
	
	export function close(){
		closing = true;
		setInterval(()=>opened=false, 100);
	}
</script>

<div class="modal-backdrop" class:close={closing}>
	<div class="modal">
		<div class="modal-heading">
			<slot name="heading"></slot>
			<button class="app_button-transparent p0" on:click={e=>close()}><Icon close/></button>
		</div>

		<div class="modal-body">
			<slot>
			</slot>
		</div>
	</div>
</div>

<style type="text/css">
	@keyframes modal{
		0%{opacity: 0;}
		100%{opacity: 1;}
	}
	@keyframes backdrop{
		0%{background: rgba(17, 21, 29, 0);}
		100%{background: rgba(17, 21, 29, .7);}
	}

	@keyframes modal-close{
		100%{opacity: 0;}
		0%{opacity: 1;}
	}
	@keyframes backdrop-close{
		100%{background: rgba(17, 21, 29, 0);}
		0%{background: rgba(17, 21, 29, .7);}
	}
	.modal-backdrop.close{
		animation: backdrop-close .1s linear; background: rgba(17, 21, 29, 0);
	}
	.modal-backdrop.close > .modal{
		animation: modal-close .1s linear; opacity: 0;  
	}
	.modal-backdrop{
		position: fixed; z-index: 10000001;
		background: rgba(17, 21, 29, 0.7);
		/*backdrop-filter: blur(7px);*/
		animation: backdrop .05s linear;
		left: 0; top: 0; width: 100vw; height: 100vh;

		display: flex;
	}

	.modal{
		animation: modal .2s linear;
		background: #0D1219;
		border: 1px solid #1A1A2A;
		box-sizing: border-box;
		box-shadow: 15px 15px 45px rgba(0, 0, 0, 0.15);
		border-radius: 7.8px;
		margin: auto;
		padding: 25px 20px;
	}

	.modal > .modal-heading{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding-bottom: 20px;
	}
	:global(.modal > .modal-heading > span){
		font-weight: 500;
		font-size: 18px;
		display: flex;
		align-items: center;
	}
	:global(.modal > .modal-heading > span > svg){
		margin-right: 10px;
		width: 20px; height: 20px;
	}
</style>